import React from "react";
import Gallery from "../../components/Gallery/Gallery";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";



export const GalleryPage= () => {
  

  return (
    <div >
      <Header />
    <Gallery />
    <Footer/>
    </div>

  );
};
